// extracted by mini-css-extract-plugin
export var infoItem = "_nw-2";
export var title = "_nw-0";
export var value = "_nw-1";